import React, {useState} from "react";
import {Box, FormHelperText, InputLabel} from "@mui/material";
import {CustomTextField} from "../../../../Shared/Components/CustomTextField";

interface Props {
    id: string;
    label: string;
    placeholder: string;
    value: string;
    error?: string;
    inputMode: "numeric" | "decimal";
    showErrors: boolean;
    onChange: (value: string) => void;
}

/**
 * Campo numérico da aba Parâmetros que aceita qualquer texto e mostra a mensagem de erro
 * enquanto o valor for inválido. O salvamento revalida e bloqueia valores inválidos.
 *
 * Valor preenchido e inválido mostra o erro na hora. Campo vazio só mostra "Campo Obrigatório."
 * depois de ser visitado ou de uma tentativa de salvar (showErrors), para não abrir a aba em
 * vermelho numa usina nova.
 */
export const PowerStationParamField = ({id, label, placeholder, value, error, inputMode, showErrors, onChange}: Props) => {
    const [touched, setTouched] = useState(false);
    const errorId = `${id}Error`;
    const visibleError = touched || showErrors || value.trim() !== "" ? error : undefined;

    return (
        <Box style={{marginBottom: 20}}>
            <InputLabel id={`${id}Label`} htmlFor={id}>{label}</InputLabel>
            <CustomTextField
                id={id}
                value={value}
                error={visibleError !== undefined}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => onChange(event.target.value)}
                onBlur={() => setTouched(true)}
                placeholder={placeholder}
                onFocus={(event: React.FocusEvent<HTMLInputElement>) =>
                    event.target.setSelectionRange(event.target.value.length, event.target.value.length)}
                inputProps={{inputMode, "aria-describedby": visibleError ? errorId : undefined}}
            />
            {visibleError && <FormHelperText id={errorId} error>{visibleError}</FormHelperText>}
        </Box>
    );
};
